import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  logs: [],
  isLoading: false,
  error: null
};

const clientPortalLogsSlice = createSlice({
  name: 'clientPortalLogs',
  initialState,
  reducers: {
    fetchLogsStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchLogsSuccess: (state, action) => {
      state.logs = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchLogsFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    addLogSuccess: (state, action) => {
      state.logs.unshift(action.payload);
    }
  }
});

export const {
  fetchLogsStart,
  fetchLogsSuccess,
  fetchLogsFailure,
  addLogSuccess
} = clientPortalLogsSlice.actions;

export default clientPortalLogsSlice.reducer; 